import { render } from "./MetadataSimpleRecords.vue?vue&type=template&id=be3845e0&ts=true"
import script from "./MetadataSimpleRecords.vue?vue&type=script&lang=ts"
export * from "./MetadataSimpleRecords.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src602189598/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__